import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import QRCode from "react-qr-code";
import {getKCISData,getData,downloadExcelReports} from '../../services/index';
import { BellOutlined, QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined,UploadOutlined,MobileOutlined,FilterOutlined,WhatsAppOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";

import { Drawer,Popconfirm } from 'antd';

import DatePickers from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
 import axios from 'axios';

import $ from 'jquery';
const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

const { RangePicker } = DatePicker;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			followup_date: new Date(),
			import_loading:false,
			csv_file:null,
			import_visible:false,
			msg: '',
			school_id: '',
			sms_text:'',
			email_subject:'',
			email_body:'',
			selection_count:0,
			sms_visible:false,
			email_visible:false,
			qr_visible:false,
			filter_visible:false,
			checkedBoxes: [],
			school_list : [],
			enquiry_list : [],
			followup_status : [],
			timeline_details : [],
			marketing_followup_details : [],
			enquiries_details : [],
			fees_setting : [],
			academic_year_ : [],
			index:0,
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			fees_view: false,
			timeline: false,
			checkAll: false,
			mobile_sms: false,
			mobile_follow: false,
			checkedList: defaultCheckedList,
			checked: false,
			enquiry_id:0,
			currentDate:'',
			assign_label:'',
			source:'',
			academic_year:'',
			follow_status:'',
			date:'',
			keyword:'',
			qr_link:'',
			program_id:'',
			priority:'Potential',
			page: 1,
			total_count:0,
			final_count:0,
			tag_name:[],
			staff_list:[],
			manage_class:[],
			template_list:[],
			perPage: 10,
			new_date:["",""],
			missed_followup_list:[],
			source_list:[],
			missed_followup_modal:false,
			source_type:'',
		}
			this.change_how_know_1 = this.change_how_know_1.bind(this);
		this.inputChange = this.inputChange.bind(this);	
		this.onChangechecked = this.onChangechecked.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.onChangebirthday = this.onChangebirthday.bind(this);	
		this.change_followup_status = this.change_followup_status.bind(this);	
		this.change_priorty = this.change_priorty.bind(this);	
		this.change_status = this.change_status.bind(this);	
		this.change_source = this.change_source.bind(this);	
		this.change_year = this.change_year.bind(this);	
		this.onChangedate = this.onChangedate.bind(this);	
		this.submit_search = this.submit_search.bind(this);	
		this.movetoenroll = this.movetoenroll.bind(this);	
		this.onChangePage = this.onChangePage.bind(this);	
		this.change_pagination = this.change_pagination.bind(this);	
		this.change_pagination = this.change_pagination.bind(this);	
	}
	
	change_how_know_1(event){
        this.setState({source_type: event});
		//document.getElementsByClassName('ant-select-selection')[6].classList.remove("error_focus");
    }
	
	addMissedfollowModal = (id) => {  
		this.setState({
		  enquiry_id: id,
		  missed_followup_modal: false,
		  addfollow: true,
		});
	};
	
	
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}
	
	change_pagination(event){
		this.setState({
            perPage: event
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	movetoenroll = (id) => {
	  var link = '/enquiries_enroll/'+id;
	  window.location.href = link;
   }; 
	
	change_source(event){
         this.setState({source: event});
    }
	change_year(event){
         this.setState({academic_year: event});
     }
	 
	 onChangedate(date, dateString) {
	  this.setState({ date: dateString });
		;
	}
	
	submit_search(){
		
		this.setState({
            filter_visible: false,
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	
	
	showFilter = () =>  {
		this.setState({
			filter_visible: true,
		});		
	}
	
	closeFilter = () =>  {
		this.setState({
			filter_visible: false,
		});	
		window.location.reload(false);	
	}
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id'],user_type:storedArray['data'][0]['type'] });
			
			var kcis_link = 'https://erp.kidzonia.co.in/panel/admin';
			var app = {user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id']}
			getData('auth/get_login_token',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						var aToken= result['data'];
						localStorage.setItem("aToken",aToken);
						var kcis_link = 'https://erp.kidzonia.co.in/panel/admin';
						this.setState({
							kcis_link: kcis_link,
							aToken:aToken
						});
					}
					else{
						var aToken='null';
						localStorage.setItem("aToken",aToken);
						var kcis_link = 'https://erp.kidzonia.co.in/panel/admin';
						this.setState({
							kcis_link: kcis_link,
							aToken:aToken
						});
					}
				}
			});
			
			
			var school_id = storedArray['data'][0]['school_id'];
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'],permission : permission,user_type : user_type});
		}
		
		this.checkData();
		
		
		$(document).ready(function(e){
		$(".check_enq").change(function(){
		  alert('hi');
		}); 
	    });	
		
	}
	
	inputChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	}
	
	sendSMS = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ loading: true });
			var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,template_id:this.state.template_id}
			getKCISData('Leads/send_whatsapp_to_selected_lead',app).then((result) => {
				let responseJson = result;
					setTimeout(() => {
						message.config({ top: 150});
						message.success('Whatsapp Sent Successfully !!',2);
						this.setState({
							sms_visible: false,
							loading: false,
							template_head: '',
							template_body: '',
							template_id: '',
						})
					}, 1200);
					
					if(result['status'] == 200){
						
					}else{
					}
				
			});
		}
	}
	
	opentemplate(e){
		this.setState({ template_id: e.target.value });
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var id = e.target.value;
		var app = {user_id:user_id,school_id:school_id,ids:this.state.checkedBoxes,id:id}
			
		getKCISData('erp/template_message_by_id',app).then((result) => {
			let responseJson = result;
				if(result['data'].length > 0){
						this.setState({
							template_head: result['data'][0]['template_head'],
							template_body: result['data'][0]['template_body'],
						});
					}
				if(result['status'] == 200){
					
				}else{
					this.setState({
						template_head: '',
						template_body: '',
					});	
				}
			
		});
	} 
	
	sendEmail= () =>{
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ loading: true });
			var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,subject:this.state.email_subject,message:this.state.email_body}
			
			getKCISData('Leads/send_new_email_to_selected_leads',app).then((result) => {
				let responseJson = result;
				setTimeout(() => {
					message.config({ top: 150});
					message.success('Email Sent Successfully !!',2);
					this.setState({
						email_visible: false,
						loading: false,
						email_subject: '',
						email_body: '',
					})
				}, 1200);
				if(result['status'] == 200){}else{}
			});
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
				
			
			
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			
			var app = {user_id : user_id,school_id:school_id,type:8}
			var app_ = {
				user_id : user_id,
				school_id:school_id,
				source:this.state.source,
				academic_year:this.state.academic_year,
				date:this.state.date,
				keyword:this.state.keyword,
				page:this.state.page,
				assign_label:this.state.assign_label,
				staff:this.state.staff,
				type:'external',
				program_id:this.state.program_id,
				source_type:this.state.source_type,
				per_page: this.state.perPage
				
				}
			getKCISData('Leads/today_leads_list',app_).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_school: result['total_data'],
							total_count: result['total_data'],
							final_count: result['final_count'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
			getKCISData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
							
						});
					}
				}
			});	
			getKCISData('erp/tag_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							tag_name: result['data'],
						});
					}else{
						this.setState({
							tag_name: '',
							
						});
					}
				}
			});
			getKCISData('erp/filter_staff_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							staff_list: result['data'],
						});
					}else{
						this.setState({
							staff_list: '',
							
						});
					}
				}
			});
			getKCISData('Leads/program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							manage_class: result['data'],
						});
					}else{
						this.setState({
							manage_class: [],
							
						});
					}
				}
			});	
			getKCISData('erp/template_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
						this.setState({
							template_list: result['data'],
						});	
				}else{
					this.setState({
						template_list: [],
						
					});
				}
				}
			});	
			getKCISData('common/get_followup_status',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
						this.setState({
							followup_status: result['data'],
						});	
				}else{
					this.setState({
						followup_status: [],
						
					});
				}
				}
			});
			getKCISData('common/source_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							source_list: result['data'],
						});
					}else{
						this.setState({
							source_list: [],
						});
					}
				}
			});
		}
	}
  
	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			document.getElementById('open_action_1_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			document.getElementById('open_action_1_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}
	}

		
	 
	deletedata = (id) => {
		if(this.state.checkedBoxes.length>0){
			var app = {user_id : this.state.user_id,id:this.state.checkedBoxes,school_id:this.state.school_id}
			getKCISData('Leads/lead_delete',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							marketing_delete: result['data'],
						});
						this.checkData();
						message.config({ top: 150});
						message.success('Selected enquiries deleted',2);
					}else{
						this.setState({
							marketing_delete: [],
						});
					}
				}
			});
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}; 
  
	movetoprinciple = (id,a) => {
	var app = {user_id : this.state.user_id,id:id,school_id:this.state.school_id}
			getKCISData('erp/enquiry_move_principle_approval',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							marketing_delete: result['data'],
						});
						message.config({ top: 150});
						message.success('Enquiry Move To Admission',2);
					}else{
						this.setState({
							marketing_delete: [],
							
						});
					}
				}
			});
	window.location.reload(false);
	}; 
  
	showSMS = () => {		
		if(this.state.checkedBoxes.length>0){
			this.setState({
				sms_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}

	handleSMSOk = e => {
		this.setState({
			sms_visible: false,
		})
	}

	CancelMissedFollowup = e => {
		this.setState({
			missed_followup_modal: false,
		})
	}

	handleSMSCancel = e => {
		this.setState({
			sms_visible: false,
		})
	}
	
	showEmail = () => {
		if(this.state.checkedBoxes.length>0){
			this.setState({
				email_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}
	
	get_selected_enquiries(){	 
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var app = {user_id:user_id,school_id:school_id,ids:this.state.checkedBoxes}
			
		getKCISData('Leads/get_leads_list_by_ids',app).then((result) => {
			let responseJson = result;
			
				if(result['status'] == 200){
					this.setState({
						enquiry_list: result['data'],
						modal_print: true
					});
					
				  if(document.getElementById('text_alert_3')){				
					document.getElementById('text_alert_3').innerHTML = '';
				   }	
					
				}else{
					this.setState({
						enquiry_list: [],
						modal_print: true
					});	
					
					if(document.getElementById('text_alert_3')){
					document.getElementById('text_alert_3').innerHTML = 'No Data Found';
				   }
				}
			
		});
			
	}

	handleEmailOk = e => {
		this.setState({
			email_visible: false,
		})
	}

	handleEmailCancel = e => {
		this.setState({
			email_visible: false,
		})
	}
  
  showModalfollowup = (id) => {
    this.setState({
      followup: true,
	  enquiry_id:id
    });
	//document.getElementById('open_action_' + id).classList.remove('is-active');
	var app = {user_id : this.state.user_id,enquiry_id:id}
		getKCISData('Leads/lead_timeline_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						marketing_followup_details: result['data'],
					});
				}else{
					this.setState({
						marketing_followup_details: [],
					});
				}
			}
		});
	};

  handleOkfollowup = e => {
    console.log(e);
    this.setState({
      followup: false,
    });
  };

  handleCancelfollowup = e => {
    console.log(e);
    this.setState({
      followup: false,
    });
  };
  
  showModaltimeline = (id) => {
    this.setState({
	  enquiry_id:id,
      timeline: true,
    });
	
	var app = {user_id : this.state.user_id,id:id}
			getKCISData('Leads/lead_timeline_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							timeline_details: result['data'],
						});
					}else{
						this.setState({
							timeline_details: [],
							
						});
					}
				}
			});
  };

  handleOktimeline = e => {
    console.log(e);
	
    this.setState({
      timeline: false,
      addfollow: false,
    });
	
  };

  handleCanceltimeline = e => {
    console.log(e);
    this.setState({
      timeline: false,
      addfollow: false,
    });
	
  };
  
	addfollowModal = (id) => {  
		this.setState({
		  addfollow: true
		});
	};
  
	

  addfollowOk = e => {
    console.log(e);
    this.setState({
      addfollow: false,
    });
	
  };

  addfollowCancel = e => {
    console.log(e);
    this.setState({
      addfollow: false,
    });
	
  };
  
  
 statusModal = () => {
    this.setState({
      status_view: true,
    });
  };

  statusOk = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };

  statusCancel = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };

  
	
  
	handleSearch=(e)=>{
		setTimeout(() => {
			this.setState({ page: 1 });
			this.checkData();
		}, 300);
	}
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				user_id: this.state.user_id,
				enquiry_id: this.state.enquiry_id,
				status: this.state.follow_status,
				remark: this.state.remark,
				followup_date: this.state.followup_date,
				priority: this.state.priority 
			}
			getKCISData('Leads/add_lead_followup',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					
					message.config({ top: 150});
					message.success('Followup added',2);
					this.setState({ loading: false,addfollow: false,timeline: false,remark:'', followup_date : new Date(),priority:'Potential',enquiry_id:'' });
					this.checkData();
					this.getTimeline(this.state.enquiry_id);
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	getTimeline= (id) => {
		var app = {user_id : this.state.user_id,id:id}
		getKCISData('Leads/lead_timeline_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						timeline_details: result['data'],
					});
				}else{
					this.setState({
						timeline_details: [],
						
					});
				}
			}
		});
	}
  
	onChangechecked(checkedValues) {
		this.setState({ checked_id: this.state.checked_id.concat(checkedValues) });
	}	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};
	
	onChangebirthday(date, dateString) {
	 this.setState({ followup_date: dateString });
	}
	
	change_priorty(event){
         this.setState({priority: event});
    }
	
	change_followup_status(event){
         this.setState({follow_status: event});
    }
	
	change_status(event){
         this.setState({
						status: event,
						status_view: true,
						});
		if(event === 'Pending'){
			this.setState({
						status_title: 'Are you sure to change status to pending ?',
						});
		}				
		if(event === 'Confirm'){
			this.setState({
						status_title: 'Are you sure to confirm the admission?',
						});
		}	
		if(event === 'Reject'){
			this.setState({
						status_title: 'Are you sure to reject?',
						});
		}
		if(event === 'Cancle'){
			this.setState({
						status_title: 'Are you sure to cancel?',
						});
		}		
     }
	 
  statusModal = () => {
    this.setState({
      status_view: true,
    });
  };

  statusOk = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };

  statusCancel = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };
  
  

  feesOk = e => {
    console.log(e);
    this.setState({
      fees_view: false,
    });
  };

  feesCancel = e => {
    console.log(e);
    this.setState({
      fees_view: false,
    });
  };
  
  onChange = e => {
    console.log('checked = ', e.target.checked);
    this.setState({
      checked: e.target.checked,
    });
  };
  

  
 calculateDiscountAmt (listPrice, discount){
  listPrice = parseFloat(listPrice);
  discount  = parseFloat(discount);
  return (( listPrice * discount / 100 )).toFixed(2);
}
 calculateDiscountPer(listPrice, salePrice){
  listPrice = parseFloat(listPrice);
  salePrice = parseFloat(salePrice);
  return  (salePrice * 100 / listPrice).toFixed(2);
}
  
   
  
  
   discount_check = (i,index,e) => { 
		//console.log(e.target.value);
	
		var discount_amt=e.target.value
		var due_amount=$('#due_amount_'+this.state.extra_fees_id+'_'+i+'_'+index).val();
		
		if(Number(discount_amt)>Number(due_amount)){
		 message.config({ top: 150});
         message.error('Discount cant not be greater than Due Amount!',2);
		 $("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		}
		else{		
		var cal_discount_per=this.calculateDiscountPer(due_amount,discount_amt);	
		//alert(cal_discount_per);
		
		$("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val(cal_discount_per);
		var payable_amt=parseFloat(due_amount)-parseFloat(discount_amt);
		$("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val(payable_amt);		
		}
   }  
   
   discount_per_check = (i,index,e) => { 
		//console.log(e.target.value);
		
		var discount_per=e.target.value
		if(Number(discount_per)>100){
		 message.config({ top: 150});
         message.error('Discount Percentage cant not be greater than 100!',2);
		 $("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		}
		else{		
		var due_amount=$('#due_amount_'+this.state.extra_fees_id+'_'+i+'_'+index).val();
		var cal_discount_amount=this.calculateDiscountAmt(due_amount,discount_per);		
		 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val(cal_discount_amount);
		 var payable_amt=parseFloat(due_amount)-parseFloat(cal_discount_amount);
		 $("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val(payable_amt);	
		 }
   }
   
    payable_amt_check = (i,index,e) => { 				
	 $("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
	 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');			
	}
   

     
   
    toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true});
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
  handleCheckbox = (e, s) => {
    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
		checkedBoxes.push(s)
    } else {
		const index = checkedBoxes.findIndex((ch) => ch === s);
		checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes,selection_count:checkedBoxes.length});
  }
  
	handleDateChange = date => {
		this.setState({
			followup_date: date
		});
	};
	
	
	change_label(event){
        this.setState({assign_label: event});	
     }
	
	change_staff(event){
        this.setState({staff: event});	
     }
	
	change_program(event){
        this.setState({program_id: event});	
     }
   

	render() {
	const {aToken}=this.state;
	var lenght = this.state.school_list.length; 
	var followup_lenght = this.state.marketing_followup_details.length; 
	

		return (
				<>
				
				<Modal
				 title="Missed Followup"
				 visible={this.state.missed_followup_modal}
				 className="missed-followup-modal"
				 onCancel={this.CancelMissedFollowup}
				 width={1100}
				>
				
				<div class="col col-md-12 s12 no-padd">
					<div class="table-responsive">
					   <table class="table table-striped table-bordered table-hover">
						  <thead>
							 <tr>
								<th>#</th>
								<th>Campaign</th>
								<th>Parent Name</th>
								<th>Child Name</th>
								<th>Class</th>
								<th>Date of Leads</th>
								<th>Followup Date</th>
								<th>Source</th>
								<th>Added By</th>
							 </tr>
						  </thead>
						  <tbody>
							{this.state.missed_followup_list.map((list,index) => (
								<>
								{(() => {  
									if ((index+1) < 6) {
										return (
											<>
												<tr onClick={this.addMissedfollowModal.bind(this,list.id)}>
													<td>{index+1}</td>
													<td>{list.c_name}</td>
													<td>{list.name}
													<span class="d-block">{list.primary_mobile}</span>
													</td>
													<td>{list.child_name}</td>
													<td>{list.class_name}</td>
													<td>{list.date_of_lead}</td>
													<td>{list.followup_date}</td>
													<td>{list.how_know}</td>
													<td>{list.added_by}</td>
												</tr>
											</>
										)
									}		
								})()}
                                 	
								</>
							))}	
						   </tbody>
					   </table>
					</div>
				</div>
				
				</Modal>
				
				<Modal
				 title="Send Whastapp Message"
				 visible={this.state.sms_visible}
				 className="send-sms"
				 onOk={this.handleSMSOk}
				 onCancel={this.handleSMSCancel}
				>
				
				<div class="col col-md-12 s12 no-padd">
					<label><b>SELECTED COUNT :</b> {this.state.selection_count}</label><br/>
				</div>
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template</b></label>
					<select  placeholder="Select Template" value={this.state.template_id} name="template_id" id="template_id" className="form-control changeSchool" onChange={this.opentemplate.bind(this)}>
							<option value="0">Select Template</option>
						{this.state.template_list.map((list)=>(
							<option value={list.template_code}>{list.name} - {list.template_code}</option>
						))}	
					</select>
				</div>
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template Head</b></label>
					 <input  disabled id="template_msg" value={this.state.template_head}/>
				</div>
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template Body</b></label>
					 <TextArea rows={6}  disabled id="template_msg" value={this.state.template_body}/>
				</div>
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.sendSMS.bind(this)} loading={this.state.loading}>Send Now</Button>
				</div>
				</Modal>
				
				
				
				<Modal
				 title="Send Email"
				 visible={this.state.email_visible}
				 className="send-sms"
				 onOk={this.handleEmailOk}
				 onCancel={this.handleEmailCancel}
				>
				
				<div class="col col-md-12 s12 no-padd mb-20 mt-20">
				 <label >Email Subject</label>
				 <input type="text" placeholder="Enter Title here" name="email_subject" value={this.state.email_subject} onChange={this.inputChange} class="form-control"/>
				</div>
				<div class="col col-md-12 s12 no-padd">
				  <label >Email Body</label>
				  <TextArea
					  placeholder="Your Text Goes Here !!"
					  autoSize={{ minRows: 2, maxRows: 6 }}
					  name="email_body"
					  value={this.state.email_body}
					  onChange={this.inputChange}
					/>
				</div>
				
				
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.sendEmail.bind(this)} loading={this.state.loading}>Send Now</Button>
				</div>
				</Modal>
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Today Followup
									
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://sandboxerp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Today Followup  </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>

				
				<div class="row">
					<div class="card-body">
						<ul class="nav nav-tabs nav-tabs-solid">
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/dashboard`} class="nav-link ">Dashboard</Link></li>
							<li class="nav-item"><a href={`${this.state.kcis_link}/campaign?t=${aToken}&s=${this.state.erp_id}`} class="nav-link" >Manage Campaign</a></li>
							
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/list`} class="nav-link ">Leads</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/today`} class="nav-link active">Today Followup </Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/missed`} class="nav-link ">Missed Followup </Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/move`} class="nav-link ">Move Leads </Link></li>
							<li class="nav-item"><a href={`${this.state.kcis_link}/field-staff?t=${aToken}&s=${this.state.erp_id}`} class="nav-link" >Manage Field Staff </a></li>
						</ul>
					</div>
				</div>
				
				<div class="hidden">
				  <div class="card">
					<div class="card-body">
						
						<div class="row">
						
												
						<div class="col-md-3">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Date</b></label>
								 <RangePicker className="date-range" onChange={this.onChangedate.bind(this)} />
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Child Name</b></label>
								 <input type="text" class="form-control" placeholder="Child Name" name="keyword" value={this.state.keyword} onChange={this.handleSizeChange}/>
							</div>
						</div>
						<div class="col-md-2 hidden">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Class</b></label>
								<Select onChange={this.change_program.bind(this)} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
											<Select.Option value=''>All</Select.Option>
										{this.state.manage_class.map((list) => (
												<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
								</Select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
							<label style={{paddingTop: '8px'}}>Academic Year</label>
							<Select onChange={this.change_year} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
								{this.state.academic_year_.map((list) => (
									<Select.Option value={list.name}>{list.name}</Select.Option>
								))}
							</Select>
							</div>
						</div>
						<div class="col-md-2 hidden">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Status</b></label>
								<Select onChange={this.change_label.bind(this)} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
									<Select.Option value=''>All</Select.Option>
									{this.state.tag_name.map((list)=>(
									<Select.Option value={list.name}>{list.name}</Select.Option>
									))}
								</Select>
							</div>
						</div>
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Source</b></label>
								<Select onChange={this.change_source.bind(this)} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
										{this.state.source_list.map((list) => (	
											<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
								</Select>
							</div>
						</div>
						
						<div class="col-md-2 hidden">
							<div class="form-group">
							    <label>Source Type</label>
								<Select onChange={this.change_how_know_1} defaultValue={this.state.source_type}>
									<Select.Option value="">Select</Select.Option>
									<Select.Option value="Lead (Social Media)">Lead (Social Media)</Select.Option>
									<Select.Option value="Walk In">Walk In</Select.Option>
									<Select.Option value="Phone Call">Phone Call</Select.Option>
								</Select>
							</div>
						</div>
						
						<div class="col-md-2 hidden">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Added By</b></label>
								<Select onChange={this.change_staff.bind(this)} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
									<Select.Option value=''>All</Select.Option>
									<Select.Option value='106'>Admin</Select.Option>
									<Select.Option value='0'>From Website</Select.Option>
									{this.state.staff_list.map((list)=>(
									<Select.Option value={list.id}>{list.name}</Select.Option>
									))}
								</Select>
							</div>
						</div>
						
						
						<div class="col-md-2">
							<div class="form-group">
								 <p>&nbsp;</p>
								 <Button className="btn btn-primary mr-2" style={{display: 'block'}} id="submit_btn" onClick={this.handleSearch.bind(this)} >Apply</Button>
							</div>
						</div>
						</div>
				  </div>
				  </div>
               </div>
			   
			  
			   
			    <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 form-group">
					 <div class="card">
						<div class="card-body">
						
						<div class="row">
						<div class="col-sm-3 col-12 text-left  enquiry-btn ">
							<h4 class="header-title ">Total Today Followup : {this.state.total_count}</h4>
						</div>
						<div class="col-sm-9 col-12 text-right  enquiry-btn mt-5px">
							
							{(() => {
							if ((this.state.permission.find(element => element == 41)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
								return (
								<>
									<button onClick={this.showSMS} type="button" className="btn btn-primary new-btn mr-1 "><WhatsAppOutlined />  Send Whastapp</button>
								</>
								)
							}
							})()}
							
							{(() => {
							if ((this.state.permission.find(element => element == 42)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
								return (
								<>
									<button onClick={this.showEmail} type="button" className="btn btn-primary new-btn mr-1 "><MailOutlined />  Send Email</button>
								</>
								)
							}
							})()}
							
							{this.state.user_type == 'admin' && (<>
							
							
							
							
							</>)}
							{this.state.user_type == 'admin' && (<>
							<Popconfirm
									title="Are you sure you want to archive?"
									onConfirm={this.deletedata}
									okText="Yes"
									cancelText="No"
								  >
									<button className="btn btn-primary new-btn mr-1" on><DeleteOutlined /> Archive</button>
						   </Popconfirm>
							</>)}	
						</div>
						</div>
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
                                    <th>
									{(() => {
										if (this.state.checked==true) {
											return (
												<>
												<Checkbox  
													onClick={this.toggleUnChecked.bind(this)}
													checked="checked"
												>
												</Checkbox>
												</>
											)
										}
										else{
											return (
												<>
												<Checkbox  
													onClick={this.toggleChecked.bind(this)}
													checked=""
												>
												</Checkbox>
												</>
											)
										}
									})()}
									</th>
                                    <th>Action</th>
                                    <th>#</th>
                                    <th>Campaign</th>
                                    <th>Academic Year</th>
                                    <th>Parent Name</th>
                                    <th>Child Name</th>
									<th>Class</th>
									<th>Priority</th>
									<th>Remark</th>
									<th>Followup Date</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {this.state.school_list.length == 0 && (<><tr><td colspan="13" class="text-center">No Leads Found</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr class={` ${list.is_enroll == 1 ? 'class-enroll' : ''} ${list.assign_label=='Lost' ? 'class-lost' : ''} `}>
									<td> 
										
										<Checkbox  
										name="checked_id[]"
										value={list.id}
										checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
										onChange={(e) => this.handleCheckbox(e, list.id)}
										>
										</Checkbox>
										
									</td>
									<td>
										
										<div class="dropright dropright">
											<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<i class="mdi mdi-dots-vertical"></i>
											</button>
											<ul class="dropdown-menu">
												<li> 
													<a href="javascript:void(0)" class="dropdown-item"  onClick={this.showModaltimeline.bind(this,list.id)}><i class="ri-history-line"></i>&nbsp; Timeline</a>
												</li>
												{list.is_enroll == 0 && (<>
												<li>
													<Link class="dropdown-item" to={`${process.env.PUBLIC_URL}/leads/edit/${list.id}`}>
														<i class="ri-edit-line"></i>&nbsp; View & Edit
													</Link>
												</li>
												<li> 
													<a href="javascript:void(0)" class="dropdown-item hidden"   onClick={this.movetoenroll.bind(this,list.id)}><i class="ri-wallet-line"></i>&nbsp;  Enroll To Process Admission</a>
												</li>
												</>)}
											</ul>
										</div>
										
                                    </td>
                                    <td>{index+1}</td>
									<td>{list.c_name}</td>
									<td>{list.academic_year}</td>
                                    <td>{list.name}
									<span class="d-block">{list.mobile}</span>
									</td>
                                    <td>{list.child_name}</td>
                                    <td>{list.class_name}</td>
                                    <td>{list.priority}</td>
                                    <td>{list.remark}</td>
                                    <td>{list.added_date}</td>
                                    
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
                        </div>
						<div class="fl-right">
			<Pagination
				activePage={this.state.page}
				itemsCountPerPage={10}
				totalItemsCount={this.state.total_count}
				pageRangeDisplayed={3}
				onChange={this.onChangePage.bind(this)}
			/>
		</div>
		
		<Select onChange={this.change_pagination} value={this.state.perPage} className="page-count-change">
								<Select.Option value="10">10</Select.Option>
								<Select.Option value="20">20</Select.Option>
								<Select.Option value="50">50</Select.Option>
								<Select.Option value="100">100</Select.Option>
							</Select>
		
		
                        </div>
                        </div>
						
				
						
                     </div>
                  </div>
               </div>
               
			   
			   
			   <Drawer
				title="Timeline"
				placement="right"
				width={400}
				closable={true}
				onClose={this.handleCanceltimeline}
				visible={this.state.timeline}
				className="mobile-drawer"
			>
				<div class="followup-model timelines">
					{this.state.timeline_details.map((list) => (	
					<Timeline.Item color="blue">
						<p class="font-blue">{list.added_date}</p>
						<div class="card-content row no-margin">
								<div class="children bg-blue timeline communication iq-card2">
									<Collapse
										bordered={false}
									  >
										<Panel header={list.title} key={list.id}>
											{(() => {  
										if (list.type =='log') {
										return (
											<>
											</>
												)
												}
												else{
													return (
		<table>
		{list.status !='' ? (<><tr><td><b>Status  :</b></td><td>{list.status}</td></tr></>):('')}
		<tr><td><b>Remark  :</b></td><td>{list.remark}</td></tr>
		<tr><td><b>Priority  :</b></td><td>{list.priority}</td></tr>
		<tr><td><b>Followup Date  :</b></td><td>{list.followup_date}</td></tr>
		</table>
												)
												}
											})()}
										</Panel>
										
									  </Collapse>
								</div>
						</div>
					</Timeline.Item >
					))}
					<div class="add_followup">
						<button className="btn btn-primary" onClick={this.addfollowModal.bind(this,this.state.enquiry_id)}><i class="ri-add-fill"></i> Add Followup</button>
					</div>
				</div>
			</Drawer>

			
			
			
			
			<Drawer
				title="Filter"
				placement="left"
				width={400}
				closable={true}
				onClose={this.closeFilter}
				visible={this.state.filter_visible}
				className="mobile-drawer Profile-view"
			>
			<div class="filter fees">
				<div class="col m4 s12 mb-20 no-padd">
						<label>Source</label>
						<Select class="form-control" placeholder="Select Source" mode="multiple" allowClear onChange={this.change_source}>
							<Select.Option value="Digital Ads">Digital Ads</Select.Option>
							<Select.Option value="Facebook">Facebook</Select.Option>
							<Select.Option value="Flayers">Flayers</Select.Option>
							<Select.Option value="Perent referral">Perent referral</Select.Option>
							<Select.Option value="Poster Ads">Poster Ads</Select.Option>
							<Select.Option value="Staff referral">Staff referral</Select.Option>
							<Select.Option value="Walk In">Walk In</Select.Option>
							<Select.Option value="Website">Website</Select.Option>
						</Select>
						
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Year</label>
						<Select onChange={this.change_year}>
										{this.state.academic_year_.map((list) => (
											<Select.Option value={list.id}>{list.academic_year}</Select.Option>
										))}
									</Select>
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Date Of Collection</label>
						<DatePicker onChange={this.onChangedate} />
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Search Keyword</label>
						<input type="text" class="form-control" name="keyword" onChange={this.handleSizeChange} />
					</div>
					<div class="col m4 s12 mb-20 no-padd">						
						<button type="button" class="primary-btn right ml-1" onClick={this.submit_search}>
							Submit
						</button>
						<button onClick={this.closeFilter} type="button" class="cancel-btn right ml-1">
							Cancel
						</button>
					</div>
				</div>
			</Drawer>
			
				
				
				<Modal
					title="Follow Up"
					visible={this.state.followup}
					className="followup-model "
					onOk={this.handleOkfollowup}
					onCancel={this.handleCancelfollowup}
				>
				<div class="col col-md-12 s12">											
					{(() => {  
						if (followup_lenght =='0') {
						return (
									<h3 class="center">No Followup Found !!</h3>
								)
							}
					})()}
					 <Timeline>
					 {this.state.marketing_followup_details.map((list) => (	
						<Timeline.Item color="blue">
							<p class="font-blue">{list.added_date}</p>
							<div class="card-content border row no-margin">
								<div class="col col-md-12 s12 pt-10 pb-10">
									<p><b>Remark : </b>{list.remark}</p>
									<p><b>Follow Up Date : </b>{list.followup_date}</p>
									<p><b>Priority By : </b>{list.priority}</p>
									<p><b>Attended By : </b>{list.user_name}</p>
								</div> 
							</div>
						</Timeline.Item >
						))}
					  </Timeline>
					  
					  
				</div>	
				</Modal>
				
				<Modal
				 title="Add Follow Up"
				 visible={this.state.addfollow}
				 className="followup-model view-Profile"
				 onOk={this.addfollowOk}
				 onCancel={this.addfollowCancel}
				>
				<div class="col m6 s12 mt-10 form-group">
					<label>Status </label>
					<Select onChange={this.change_followup_status} defaultValue="Select Status">
						<Select.Option value="">Select Status</Select.Option>
						{this.state.followup_status.map((fol) => (
						<Select.Option value={fol.name}>{fol.name}</Select.Option>
						))}
					</Select>
				</div>
				
				<div class="col col-md-12 s12 form-group">
					<input type="hidden" class="form-control" name="enquiry_id" id="enquiry_id" value={this.state.enquiry_id}/>
					<label>Remark</label>
					<TextArea
						placeholder="Your Text Goes Here !!"
						class="form-control"
						autoSize={{ minRows: 6, maxRows: 6 }}
						className=""
						onChange={this.handleSizeChange}
						name="remark"
						value={this.state.remark}
					/>
				</div>	
				<div class="col m6 s12 mt-10 datetime_picker form-group">
					<label>Follow Up Date</label>
					<DatePickers
						selected={this.state.followup_date}
						onChange={this.handleDateChange}
						minDate={new Date()}
						showTimeSelect
						timeIntervals={15}
						timeCaption="Time"
						dateFormat="MMMM d, yyyy h:mm aa"
					/>
				</div>
				<div class="col m6 s12 mt-10 form-group">
					<label>Priority </label>
					<Select onChange={this.change_priorty} value={this.state.priority}>
						<Select.Option value="Potential">Potential</Select.Option>
						<Select.Option value="Needs Follow up">Needs Follow up</Select.Option>
						<Select.Option value="Tentative ">Tentative </Select.Option>
						<Select.Option value="Might Turn Up">Might Turn Up</Select.Option>
						<Select.Option value="Lost">Lost</Select.Option>
					</Select>
				</div>
				
				
				<div class="col col-md-12 s12 text-center mt-20">
					<Button className="btn btn-primary" onClick={this.handleSubmit} loading={this.state.loading}>Add</Button>
				</div>
				</Modal>	
			
			</>
		) 
	} 
}
export default Index;
